import React from 'react';
import { Link } from 'react-router-dom';
import './ISO27701.css';

const ISO27701 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 27701 Personal Data Management System</h1>
            <h2 className="page-subtitle">The Key to Safety: Your Data Secure with ISO 27701</h2>
            <div className="page-text-content">
              <p>
                As NQC (Nova Quality Certification Agency), we understand the importance of effectively 
                managing personal data, and we add value to your business with our expertise in ISO 27701 
                standard. In this article, we will delve into what ISO 27701 Personal Data Management 
                System is, the advantages it offers to businesses, and how it is implemented in detail.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 27701?</h2>
            <div className="page-text-content">
              <p>
                ISO 27701 is a management system aimed at regulating personal data processing activities 
                and enhancing personal data security. Essentially, ISO 27701 integrates with ISO 27001 
                Information Security Management System to strengthen organizations' personal data 
                management processes. This standard provides a framework for organizations that aim to 
                gain customer trust, comply with legal regulations, and enhance data security.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Principles of ISO 27701:</h2>
            <div className="principles-list">
              <div className="principle-item">
                <h3 className="principle-title">1. Personal Data Processing Processes</h3>
                <p className="principle-description">
                  ISO 27701 includes principles for identifying, managing, and continuously improving 
                  personal data processing activities. Through this standard, organizations can effectively 
                  handle and protect personal data.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">2. Legal Compliance</h3>
                <p className="principle-description">
                  ISO 27701 guides organizations in making personal data processing activities compliant 
                  with legal regulations, allowing them to work in accordance with data protection 
                  regulations.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">3. Communication with Data Subjects</h3>
                <p className="principle-description">
                  The standard emphasizes effective communication with data subjects and respecting their 
                  rights. This not only increases customer trust but also highlights the importance of 
                  transparent personal data management processes.
                </p>
              </div>
              <div className="principle-item">
                <h3 className="principle-title">4. Risk Assessment and Improvement</h3>
                <p className="principle-description">
                  ISO 27701 enables organizations to identify and manage risks in personal data processing 
                  activities effectively. It also provides flexibility to organizations through continuous 
                  improvement principles.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 27701 for Businesses:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">1. Customer Trust and Reputation</h3>
                <p className="advantage-description">
                  Having ISO 27701 certification assures customers that personal data is processed securely, 
                  thus enhancing reputation and trust.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">2. Legal Compliance</h3>
                <p className="advantage-description">
                  ISO 27701 helps businesses operate in compliance with data protection regulations, 
                  fulfilling their legal responsibilities.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">3. Competitive Advantage</h3>
                <p className="advantage-description">
                  By documenting their commitment to personal data security with ISO 27701, businesses 
                  can gain a competitive advantage.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">4. Efficiency in Data Processing Processes</h3>
                <p className="advantage-description">
                  ISO 27701 guides organizations in identifying, improving, and optimizing data processing 
                  processes, thereby increasing efficiency.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Implement ISO 27701?</h2>
            <div className="page-text-content">
              <p>
                The implementation steps of ISO 27701 may vary depending on the size and complexity of the 
                organization. However, generally, the implementation steps can be summarized as follows:
              </p>
            </div>
            <div className="steps-list">
              <div className="step-item">
                <h3 className="step-title">1. Initial Assessment</h3>
                <p className="step-description">
                  The organization evaluates existing personal data processing processes and identifies 
                  areas for improvement.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">2. Policy and Process Development</h3>
                <p className="step-description">
                  Suitable policies and processes are developed for ISO 27701. This includes identifying 
                  personal data processing activities, conducting risk assessments, and managing them.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">3. Training and Awareness</h3>
                <p className="step-description">
                  Personnel are trained on ISO 27701 standards and the organization's personal data 
                  management policies, creating awareness.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">4. Documentation and Monitoring</h3>
                <p className="step-description">
                  Documentation compliant with ISO 27701 requirements is created, and processes are 
                  regularly monitored.
                </p>
              </div>
              <div className="step-item">
                <h3 className="step-title">5. Audit and Improvement</h3>
                <p className="step-description">
                  Compliance with ISO 27701 standards is regularly audited, and action plans for 
                  continuous improvement are established.
                </p>
              </div>
            </div>
            <div className="page-text-content">
              <p>
                ISO 27701 provides a framework for personal data management, helping organizations enhance 
                data security and operate in compliance with legal regulations. This standard is an 
                essential tool for businesses aiming to gain customer trust and a competitive edge.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO27701;

